import {setup} from "axios-cache-adapter";

export default async function initBadge(win) {
    // loop through all product tiles
    const products = win.document.querySelectorAll(`.product-tile`);

    const acousticHost = "https://content-eu-1.content-cms.com";
    const acousticContentHubId = "f43b0181-6ee9-4539-b3e9-f7f37a95f962";
    const acousticBaseUrl = `${acousticHost}/api/${acousticContentHubId}`;
    const acousticDeliverySearchBaseUrl = `${acousticBaseUrl}/delivery/v1/search`;
    const acousticRenderingBaseUrl = `${acousticHost}/${acousticContentHubId}`;

    const api = setup({
        // `axios` options
        baseURL: acousticBaseUrl,
        // `axios-cache-adapter` options
        cache: {
            exclude: {query: false},
            maxAge: 60 * 60 * 1000, // 1hr
        },
    });

    for (const product of products) {
        // build solr search params
        let productCode = parseFloat(product.dataset.productCode);
        let searchParams = new URLSearchParams();
        let domain = window.location.hostname || 'reece.com.au';
        searchParams.append("fl", "generatedFiles");
        searchParams.append("fq", "classification:(content)");
        searchParams.append("fq", 'type:("badge widget")');
        searchParams.append("sort", "sortableNumber1 asc");
        searchParams.append("q", `{!join from=categoryLeaves to=categoryLeaves v=$q1}`);
        searchParams.append("q1", `((number1:${productCode}  AND -(categories:(Reece website domain))) OR (number1:${productCode} AND (categories:(Reece website domain) AND categoryLeaves:(${domain}))))`);
        searchParams.append("rows", "1");

        // Send a GET request to fetch product badges
        api.get(acousticDeliverySearchBaseUrl, {
            params: searchParams,
            responseType: "json",
        }).then(async (response) => {
            // if any acoustic documents are found
            // Send a GET request to fetch generated badge template
            if (response.data.numFound && response.data.numFound > 0) {
                let generatedFilePath = response.data.documents[0].generatedFiles[0];

                api.get(`${acousticRenderingBaseUrl}/${generatedFilePath}`, {
                    responseType: "text",
                }).then(async (response) => {
                    // attach our new HTML
                    let badgeEl = document.createElement("div");
                    badgeEl.classList.add("badge-container");
                    badgeEl.innerHTML = response.data;
                    let containerEls = product.querySelectorAll(
                        ".pill-container"
                    );
                    if (containerEls == undefined) return;
                    containerEls[0].insertBefore(badgeEl, containerEls[0].firstChild);
                });
            }
        });
    }

    try {
        for (const product of products) {
            if (product.dataset.customOrder) {
                let badgeEl = document.createElement("div");
                badgeEl.classList.add("badge-container");

                badgeEl.innerHTML =
                    `<rg-badge priority="default" style="--badge-background-color: #94BAF6;--badge-border-color: #94BAF6;--badge-hover-background-color: #94BAF6;--badge-focus-background-color: #94BAF6;" class="hydrated">
                        <span><rg-icon icon="zmdi zmdi-time-countdown" margin="right" ratio="1" theme="" class="hydrated"></rg-icon>Made to Order</span>
                    </rg-badge>`;
                let containerEls = product.querySelectorAll(
                    ".pill-container"
                );
                if (containerEls == undefined) return;
                containerEls[0].insertBefore(badgeEl, containerEls[0].firstChild);
            }
        }
    } catch (err) {
        throw new Error(err);
    }
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/badge/index.js